export default {
  saveTemplateThumbnail(data) {
    return axios.post('/admin/auth/template/update_image', data, {
      headers: { "Content-Type": "multipart/form-data" }
    });
  }
}
